export default __webpack_public_path__ + "static/space-1-169236e2439f5c82625d880865cdf8df.jpg";